export default __webpack_public_path__ + "static/media/con-labs.8b64e63c.svg";